import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Col,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap";
import {
  ContentMap,
  ContentTypesUi, divisionMap, statusMap,
  inputFileTypes,
  msFileTypes,
  privacyMap,
  REGEX_CONSTANTS,
} from "../../globals/helpers/consts";
import { useDispatch, useSelector } from "react-redux";
import {
  addContent,
  getContent,
  setCurrentContent,
} from "../../store/actions/contentActions";
import { resetModal, setModalChild } from "../../store/actions/modalActions";
import { QuickPostForm } from "./QuickPostForm";
import { ImageDropZonePreview } from "../../globals/core/ImageDropZonePreview/ImageDropZonePreview";
import { useTranslation } from "react-i18next";
import { ChipSelect } from "../../globals/core/ChipSelect/SelectChip";
import { searchRelatedAction, searchTagsAction } from "./Content";
import { setAlert, showLoader } from "../../store/actions/mainActions";
import { extractFileExtention, openFile } from "../../globals/helpers/helpers";
import { ContentService } from "../../globals/services/content.service";
import Select from "react-select";
import { CardSelect } from "../../globals/core/CardSelect/CardSelect";
const moment = require("moment").default || require("moment");

export const AddNewContentForm = (props) => {

  /// Handle default date
  let defaultDate = new Date()
  defaultDate.setDate(defaultDate.getDate() + 3)
  const [date, setDate] = useState(defaultDate)

  const dispatch = useDispatch();
  const { currentContent, contentItems, users } = useSelector(
    (state) => state.content
  );
  const { me } = useSelector((state) => state.auth);
  const { t } = useTranslation("common");
  const checkboxClass =
    t("direction") === "rtl" ? "form-check-right" : "form-check";
  const { files } = props;
  const [extThumbnail, setExtThumbnail] = useState("");
  const [mounted, setMounted] = useState(true);

  const setOptions = () => {
    let options;
    if (currentContent) {
      options = [
        ...ContentTypesUi.map((c, i) => ({
          ...c,
          isActive: i === ContentMap.indexOf(currentContent.type),
        })),
      ];
    } else {
      options = [...ContentTypesUi.map((c) => ({ ...c }))];
    }
    return options;
  };

  const setCurrent = () => {
    return currentContent ? ContentMap.indexOf(currentContent.type) + 1 : 1;
  };

  const initialState = {
    current: setCurrent(),
    options: setOptions(),
    showMeta: currentContent ? true : false,
    selectedFiles: [],
    isFormValid: { link: false, file: false },
    isQuickPost: false,
  };
  const [state, setState] = useState(initialState);

  //NEED TO SHOW THE CURRENT BLOCK
  const initialContent = currentContent
    ? {
      ...currentContent,
      file: currentContent?.azureUrl ? currentContent.azureUrl : "",
      thumbnail: currentContent?.thumbnail ? currentContent.thumbnail : "",
      created_by: currentContent?.created_by
        ? currentContent.created_by._id
        : me?._id,
      uploaded_by: currentContent?.uploaded_by
        ? currentContent.uploaded_by._id
        : "",
      modified: currentContent?.modified ? currentContent?.modified : "",
        modified_by: currentContent?.modified_by
            ? currentContent.modified_by._id
            : "",
    }
    : {
      type: ContentMap[state.current - 1],
      title: "",
      description: "",
      tags: [],
      thumbnail: "",
      link: "",
      file: "",
      status: "Active",
      show_item_in_search: true,
      community: "",
      created_by: me?._id,
      uploaded_by: me?._id,
      modified_by: me?._id,
      who_can_see: 0,
      created_on: "",
      file_type: "",
      related: [],
      division:"",
    };

  const [content, setContent] = useState(initialContent);

  const select = (id) => {
    if (!currentContent) {
      const newContent = {
        ...initialContent,
        type: ContentMap[id - 1],
        link: currentContent ? currentContent.link : "",
        file: "",
      };
      setContent(newContent);

      const newOptions = [];
      state.options.map((o) => {
        if (o.id === id) {
          o.isActive = true;
        } else {
          o.isActive = false;
        }
        newOptions.push({ ...o });
        return o;
      });
      const newState = {
        ...initialState,
        current: id,
        options: newOptions,
      };
      setState(newState);
    } else {
      dispatch(
        setAlert({
          message: "Changing Media Item Type is not allowed",
          ok: () => {
            dispatch(setAlert(null));
          },
          s: "error",
        })
      );
    }
  };

  useEffect(() => {
    handleValidation();
    if (state.isQuickPost) {
      dispatch(setCurrentContent(contentItems[contentItems.length - 1]));
      setState({ ...state, isQuickPost: false });
      setMounted(false);
    }
  }, [content, contentItems]);

  const handleDropZone = ({ selectedFiles }) => {
    const lastFile = selectedFiles.pop();
    setState({ ...state, selectedFiles: [lastFile] });
    handleForm({ thumbnail: lastFile });
  };

  const handleTags = (tags) => {
    setContent({ ...content, tags });
  };

  const handleRelated = (related) => {
    setContent({ ...content, related });
  };

  const handleForm = (prop) => {

    if (prop.file) {
      if (prop.file.size > 1024 * 1024 * 20) {
        dispatch(setAlert({
          message: "Files greater than 20MB are not allowed",
          ok: () => {
            dispatch(setAlert(null));
            setContent({
              ...content,
              ...prop,
              file: "",
              title: ""
            });
          },
          s: "info",
        }))
        return
      }
      setContent({
        ...content,
        ...prop,
        title: prop.file.name,
        file_type: extractFileExtention(prop.file.name) && msFileTypes.includes('.' + extractFileExtention(prop.file.name)) ? extractFileExtention(prop.file.name) : "unknown"
      });
    } else {
      setContent({
        ...content,
        ...prop,
      });
    }
  };

  const flipColor = (option) => {
    if (option.isActive) {
      const o = { ...option };
      const c = option.color;
      const bg = option.bg;
      o.color = bg;
      o.bg = c;
      return o;
    }
    return option;
  };

  const handleValidation = () => {
    //HANDLES THE SWITCH BETWEEN THE CONTENT TYPES FILE AND THE LINKS
    if (state.current !== 1) {
      if (REGEX_CONSTANTS.link.test(content.link)) {
        if (
          content.type === "sefaria_link" &&
          content.link.includes("sefaria.org")
        ) {
          setState({
            ...state,
            isFormValid: { ...state.isFormValid, link: true, file: true },
          });
        } else if (
          content.type === "hartman_link" &&
          content.link.includes("hartman.org")
        ) {
          setState({
            ...state,
            isFormValid: { ...state.isFormValid, link: true, file: true },
          });
        } else if (
          content.type === "external_link" ||
          content.type === "recording_session"
        ) {
          setState({
            ...state,
            isFormValid: { ...state.isFormValid, link: true, file: true },
          });
        } else {
          setState({
            ...state,
            isFormValid: { ...state.isFormValid, link: false, file: true },
          });
        }
      } else {
        setState({
          ...state,
          isFormValid: { ...state.isFormValid, link: false, file: true },
        });
      }
    } else {
      if (content.file === "" && !currentContent) {
        setState({
          ...state,
          isFormValid: { ...state.isFormValid, link: true, file: false },
        });
      } else {
        setState({
          ...state,
          isFormValid: { ...state.isFormValid, link: true, file: true },
        });
      }
    }
    //HANDLES THE SWITCH BETWEEN THE CONTENT TYPES FILE AND THE LINKS
  };

  const isValid = () => {
    let valid = true;
    for (const property in state.isFormValid) {
      if (!state.isFormValid[property]) {
        valid = false;
      }
    }
    return valid;
  };

  const saveAndClose = async (e) => {
    try {
      const { afterPostAction } = props;
      e.preventDefault();
      //Add new CI
      if (afterPostAction) {
        if (!currentContent) {
          await dispatch(addContent({ ...content }));
          await dispatch(resetModal());
          await afterPostAction();
          if (content.type === "recording_session") {
            dispatch(
              setAlert({
                message: "Your Recording-Session will be uploaded within 24 hours.",
                ok: () => {
                  dispatch(setAlert(null));
                },
                s: "info",
              })
            );
          }
        }
        //Update current CI
        else {
          await dispatch(addContent({ ...content, modified_by: me?._id }));
          await dispatch(resetModal());
          await afterPostAction();
        }
      }
    } catch (err) {
      dispatch(
        setAlert({
          message: "Could not create item",
          ok: () => {
            dispatch(setAlert(null));
          },
          s: "error",
        })
      );
    }
  };

  const quickPost = async (e) => {
    try {
      const { afterPostAction } = props;
      e.preventDefault();
      if (afterPostAction) {
        //Add new CI
        if (!currentContent) {
          setState({ ...state, isQuickPost: true });
          await dispatch(addContent({ ...content }));
          dispatch(showLoader(true));
          await dispatch(getContent());
          dispatch(showLoader(false));
          dispatch(
            setModalChild(
              <QuickPostForm
                action="create"
                afterPostAction={afterPostAction}
              />
            )
          );
          //Update current CI
        } else {
          setState({ ...state, isQuickPost: true });
          dispatch(showLoader(true));
          await dispatch(getContent());
          dispatch(showLoader(false));
          dispatch(
            setModalChild(
              <QuickPostForm
                action="create"
                afterPostAction={afterPostAction}
              />
            )
          );
        }
      }
    } catch (err) {
      dispatch(
        setAlert({
          message: "Could not save Item",
          ok: () => {
            dispatch(setAlert(null));
          },
          s: "error",
        })
      );
    }
  };

  const renderModifiedData = () => {
    let markup = null;
    if (content) {
      markup = (
        <Card>
          <CardBody>
            <div className="row">
              <Col md={6} className="px-2">
                <FormGroup>
                  <div className="form-floating">
                    <Input
                      disabled={true}
                      value={content.modified_by ? content.modified_by : ""}
                      type="select"
                      id="modified_by"
                    >
                      {users
                        ? users.map((u, i) => {
                          return (
                            <option key={i} value={u.value}>
                              {u.label}
                            </option>
                          );
                        })
                        : null}
                    </Input>
                    <Label htmlFor="modified_by">Modified By</Label>
                  </div>
                </FormGroup>
              </Col>
              <Col md={6} className="px-2">
                <FormGroup>
                  <div className="form-floating">
                    <Input
                      disabled={true}
                      value={moment(Date.now()).format("YYYY-MM-DD")}
                      type="Date"
                      id="modified"
                    />
                    <Label htmlFor="modified">Modified Date</Label>
                  </div>
                </FormGroup>
              </Col>
            </div>
          </CardBody>
        </Card>
      );
    }
    return markup;
  };

  const renderThumbnail = () => {
    let markup = "";
    if (currentContent && files?.thumbnail) {
      markup = (
        <Col md={6} className="px-2">
          {" "}
          <FormGroup>
            <div className="form-group">
              <Label htmlFor="image" className="form-label">
                Current Thumbnail
              </Label>
              <br />
              <img src={files?.thumbnail} alt="" width="50%" height="auto" />
            </div>
          </FormGroup>{" "}
        </Col>
      );
    }
    if (extThumbnail) {
      markup = (
        <Col md={6} className="px-2">
          {" "}
          <FormGroup>
            <div className="form-group">
              <Label htmlFor="image" className="form-label">
                Current Thumbnail
              </Label>
              <br />
              <img src={extThumbnail} alt="" width="50%" height="auto" />
            </div>
          </FormGroup>
        </Col>
      );
    }
    return markup;
  };

  const getDataByLink = async (link) => {
    try {
      if (isValid()) {
        const contentService = ContentService();
        let result;
        switch (content.type) {
          case ContentMap[1]: //Sefaria link
          case ContentMap[3]: //External link
            dispatch(showLoader(true));
            result = await contentService.getOgData(link);
            break;
          case ContentMap[2]: //Hartman link
            dispatch(showLoader(true));
            result = await contentService.getWpData(link);
            break;
          default:
            break;
        }
        dispatch(showLoader(false));
        if (result && mounted) {
          setState({
            ...state,
            showMeta: true,
          });
          handleForm({
            title: result.title ? result.title : content.title,
            description: result.description
              ? result.description
              : content.description,
            tags:
              result.tags && result.tags.length > 0
                ? result.tags
                : content.tags,
          });
          setExtThumbnail(result.thumbnail);
        }
      }
    } catch (err) {
      console.error(err);
      dispatch(showLoader(false));
    }
  };

  const renderAuthoritySetter = (e) => {
    return (
      <Card>
        <CardBody>
          <div className="row">
            <div className="col-12 col-md-6 px-2 mb-3 mb-md-0">
              <div className="form-floating">
                <Input
                  disabled={true}
                  value={content.uploaded_by}
                  type="select"
                  id="uploaded_by"
                >
                  {users
                    ? users.map((u, i) => {
                      return (
                        <option key={i} value={u.value}>
                          {u.label}
                        </option>
                      );
                    })
                    : null}
                </Input>
                <Label htmlFor="uploaded_by">Uploaded By</Label>
              </div>
            </div>
            <div className="col-12 col-md-6 px-2">
              <div className="form-floating">
                <Input
                  value={content.who_can_see}
                  onChange={(e) => handleForm({ who_can_see: e.target.value })}
                  type="select"
                  id="who_can_see"
                >
                  {privacyMap.map((p, i) => (
                    <option key={i} defaultValue value={p.value}>
                      {p.label}
                    </option>
                  ))}
                </Input>
                <Label htmlFor="who_can_see">Who can see this?</Label>
              </div>
            </div>
          </div>


          <div className="row mt-2">

            <div className="col-12 col-md-6 px-2">
              <div className="form-floating">
                <Input
                    value={content.division}
                    onChange={(e) => handleForm({ division: e.target.value })}
                    type="select"
                    id="division"
                >
                  {divisionMap.map((p, i) => (
                      <option key={i} defaultValue value={p.value}>
                        {p.label}
                      </option>
                  ))}
                </Input>
                <Label htmlFor="division">Division</Label>
              </div>
            </div>

            <div className="col-12 col-md-6 px-2">
              <div className="form-floating">
                <Input
                    value={content.status ? content.status : "Active"}
                    onChange={(e) => handleForm({ status: e.target.value })}
                    type="select"
                    id="contentStatus"
                >
                  {statusMap.map((p, i) => (
                      <option key={i} defaultValue value={p.value}>
                        {p.label}
                      </option>
                  ))}
                </Input>
                <Label htmlFor="division">Status</Label>
              </div>
            </div>

          </div>
        </CardBody>
      </Card>

    );
  };

  const renderFileUploader = () => {
    return (
      <Card>
        <CardBody>
          <div className="row">
            <div className="col-12 col-md-6 px-2">
              <div
                className={
                  (state.isFormValid.file ? "" : "text-danger") +
                  " mt-3 form-group"
                }
              >
                <Label htmlFor="formFile" className="form-label">
                  Select File For Upload
                </Label>
                <Input
                  accept={
                    "application/*,image/*,video/*,audio/*," +
                    msFileTypes.join()
                  }
                  onChange={(e) => {
                    handleForm({ file: e.target.files[0] });
                  }}
                  className="form-control"
                  type="file"
                  id="formFile"
                />
                {!state.isFormValid.file ? (
                  <div className="invalid-feedback d-block">
                    No file selected
                  </div>
                ) : null}
              </div>
            </div>
            {currentContent && files?.file ? (
              <div className="col-12 col-md-6">
                <div className="mt-3 form-group">
                  <Label className="form-label">Current File</Label>
                  <div
                    className="cursor-pointer"
                    onClick={(e) => openFile(files.file, e)}
                  >
                    View file
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </CardBody>
      </Card>
    );
  };

  const renderlink = () => {
    return (
      <Card>
        <CardBody>
          <div className="row">
            <div className="col-12 col-md-6">
              <div
                className={
                  (state.isFormValid.link ? "" : "text-danger") +
                  " mt-3 form-group"
                }
              >
                <Label htmlFor="link" className="form-label">
                  Add link
                </Label>
                <Input
                  type="text"
                  onChange={(e) => {
                    handleForm({ link: e.target.value });
                  }}
                  onBlur={(e) => {
                    getDataByLink(e.target.value);
                  }}
                  value={content.link}
                  className={
                    state.isFormValid.link === true ? "valid" : "not-valid"
                  }
                  id="link"
                />
                {!state.isFormValid.link ? (
                  <div className="invalid-feedback d-block">
                    Link is not valid or not provided
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    );
  };

  const renderForm = () => {
    return (
        // {content.type === "file" ? renderFileUploader() : null}
      <Card>
        <CardBody>
          {/*<CardTitle className="h5 m-0">*/}
          {/*  <div*/}
          {/*    className={`${checkboxClass} form-switch form-switch-lg mb-0 d-flex`}*/}
          {/*  >*/}
          {/*    <div className="">*/}
          {/*      <input*/}
          {/*        type="checkbox"*/}
          {/*        className="form-check-input mt-0"*/}
          {/*        id="meta"*/}
          {/*        value={state.showMeta}*/}
          {/*        onChange={(e) => {*/}
          {/*          setState({*/}
          {/*            ...state,*/}
          {/*            showMeta: e.target.checked,*/}
          {/*          });*/}
          {/*        }}*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*    <div className="">*/}
          {/*      <label className="form-check-label mx-4" htmlFor="meta">*/}
          {/*        Additional Data - Add additional data to your content*/}
          {/*      </label>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</CardTitle>*/}

            <Form className="w-100">
              <Row className="mt-3 w-100">
                <Col md={6} className="px-2">
                  <FormGroup className="mb-3 mt-3 mt-lg-0">
                    <Label htmlFor="title">Title</Label>
                    <Input
                      onChange={(e) => {
                        handleForm({ title: e.target.value });
                      }}
                      value={content.title || ""}
                      type="text"
                      className="form-control"
                      id="title"
                      placeholder="Enter Title"
                    />
                  </FormGroup>
                </Col>
                <Col md={6} className="px-2">
                  <FormGroup className="mb-3 mt-3 mt-lg-0">
                    <Label htmlFor="description">Description</Label>
                    <textarea
                      onChange={(e) => {
                        handleForm({ description: e.target.value });
                      }}
                      value={content.description || ""}
                      row="6"
                      className="form-control"
                      id="description"
                      placeholder="Enter Description"
                    />
                  </FormGroup>
                </Col>
                <Col md={6} className="px-2">
                  <FormGroup className="mb-3 mt-3 mt-lg-0 templating-select select2-container">
                    <Label htmlFor="tags">Tags</Label>
                    <ChipSelect
                      placeholder="Search for tags"
                      tags={content.tags}
                      setTags={handleTags}
                      searchAction={searchTagsAction}
                    />
                  </FormGroup>
                </Col>
                {/* FILE TYPE INPUT */}
                <Col md={6} className="px-2">
                  <FormGroup className="mb-3 mt-3 mt-lg-0">
                    <Label htmlFor="description">File type</Label>
                    <div className="mb-3 select2-container">
                      <Select
                        value={inputFileTypes.find((ft) => {
                          return ft.value === content.file_type;
                        })}
                        onChange={(s) => {
                          handleForm({ file_type: s.value });
                        }}
                        options={
                          [...inputFileTypes, { value: "unknown", label: "unknown" }]
                        }
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </FormGroup>
                </Col>
                {/* FILE TYPE INPUT */}

                <Col md={6} className="px-2">
                  <FormGroup>
                    <Label htmlFor="title">Created Date </Label>
                    <input
                      onChange={(e) =>
                        handleForm({ created_on: e.target.value })
                      }
                      disabled={true}
                      className="form-control"
                      type="date"
                      //value={content.created_on}
                      value={content.created_on ? moment(content.created_on).format("YYYY-MM-DD") :
                          content.created ? moment(content.created).format("YYYY-MM-DD") :
                          moment(Date.now()).format("YYYY-MM-DD")}
                    />
                  </FormGroup>
                </Col>
                <Col md={6} className="px-2">
                  <FormGroup>
                    <Label htmlFor="title">Created by</Label>
                    <div className="mb-3 select2-container">
                      <Select
                        value={users.find((u) => {
                          return u.value === content.created_by;
                        })}
                        onChange={(s) => {
                          handleForm({ created_by: s.value });
                        }}
                        options={users}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col md={6} className="px-2">
                  <FormGroup className="mb-3 mt-3 mt-lg-0">
                    <Label htmlFor="image" className="form-label">
                      Select Thumbnail
                    </Label>
                    <ImageDropZonePreview
                      onChange={handleDropZone}
                      selectedFiles={state.selectedFiles}
                      accept="image/png, image/gif, image/jpeg"
                    />
                  </FormGroup>
                </Col>
                {/*<div>{state && state.file ? state.file : null}</div>*/}
                {renderThumbnail()}
                {/* <Col md={6} className="px-2 mt-2">
                  <FormGroup>
                    <div
                      className={`${checkboxClass} form-check-outline form-check-primary`}
                    >
                      <Input
                        type="checkbox"
                        className="form-check-input"
                        id="customCheck-outlinecolor1"
                        checked={
                          typeof content.show_item_in_search === "string"
                            ? JSON.parse(content.show_item_in_search)
                            : content.show_item_in_search
                        }
                        onChange={(e) =>
                          handleForm({ show_item_in_search: e.target.checked })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="customCheck-outlinecolor1"
                      >
                        Is visible in search
                      </label>
                    </div>
                  </FormGroup>
                </Col> */}
              </Row>
              <Row className="py-2">
                <Col md={8} className="px-2">
                  <FormGroup className="mb-3 mt-3 mt-lg-0 templating-select select2-container">
                    <Label htmlFor="description">Related Items</Label>
                    <CardSelect
                      placeholder="Search for Content Items"
                      cards={content.related}
                      setCards={handleRelated}
                      searchAction={searchRelatedAction}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Form>

        </CardBody>
      </Card>
    );
  };

  const switchAttachment = () => {
    if (state.current === 1) {
      return renderFileUploader();
    } else {
      return renderlink();
    }
  };

  return (
    <div className="container">
      <div className="row my-3">
        { !content.c_id ?
            <h3>Create New Content Item</h3>
            :
            <h3>Edit Content Item</h3>
        }
      </div>
      <div className="row my-2">
        <div className="h4">
          Selected Content Type - {state.options[state.current - 1]?.label}
        </div>
      </div>
      { !content.c_id ?
          <div className="row my-5 justify-content-between">
            {state.options.map((_o, oi) => {
              const o = flipColor(_o);
              return (
                  <div
                      className="col-12 col-md-2 cursor-pointer"
                      key={oi}
                      onClick={(e) => select(o.id)}
                  >
                    <div className={"card bg-" + o.bg}>
                      <div className="card-body d-flex flex-column justify-content-center align-items-center">
                        <div className={"h3 text-" + o.color}>
                          <i className={o.icon}></i>
                        </div>
                        <p className={`h3 card-text text-${o.color} card-title`}>
                          {o.label}
                        </p>
                      </div>
                    </div>
                  </div>
              );
            })}
          </div>
          : null
      }


      <div className="row my-3">{switchAttachment()}</div>
      <div className="row my-3">{renderModifiedData()}</div>
      {content.link || content.file || currentContent?.file ? (
        <React.Fragment>
          <div className="row mb-3">{renderAuthoritySetter()}</div>
          <div className="row">{renderForm()}</div>
        </React.Fragment>
      ) : null}

      <div className="row mt-5 mb-3 justify-content-md-end justify-content-center">
        <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-center">
          <Button
            disabled={!isValid()}
            onClick={saveAndClose}
            type="submit"
            color="primary"
            className="w-md mx-3"
          >
            Save & Close
          </Button>
          {!currentContent ? (
            <Button
              disabled={!isValid()}
              onClick={quickPost}
              color="success"
              className="w-md"
            >
              Save & Publish
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};
